/**
 * Reads the `login_hint` query parameter (passed by Creator when opening this
 * app) and removes it from the address bar so it is not retained in history or
 * shared in links. Returns the hint, or null when absent.
 */
export function readAndStripLoginHint(): string | null {
  const url = new URL(window.location.href);
  const hint = url.searchParams.get("login_hint");
  if (hint === null) {
    return null;
  }
  url.searchParams.delete("login_hint");
  const newSearch = url.searchParams.toString();
  const newUrl = `${url.pathname}${newSearch ? `?${newSearch}` : ""}${url.hash}`;
  window.history.replaceState({}, "", newUrl);
  return hint;
}
